import { gql } from '@apollo/client';

export const FLEET = gql`
  query Fleet($fleetId: Int!) {
    fleet(fleetId: $fleetId) {
      id
      name
      transferCompanyId
      transferCompany {
        name
      }
      active
      acceptNewRides
      lockedForComplaints
      timeZoneId
      availableTravelAddons
      availableVehicleCategories
      strictlyEnforceCapacity
      offerEmail
      customerSupportInfo {
        fullTimeSupport
        openingHoursFrom
        openingHoursTo
        email
        phone
        emergencyEmail
        emergencyPhone
      }
    }
  }
`;

export const FLEETS = gql`
  query transferCompanyFleets($transferCompanyId: Int!, $size: Int) {
    transferCompanyFleets(transferCompanyId: $transferCompanyId, size: $size) {
      results {
        id
        name
        transferCompanyId
        active
        acceptNewRides
        lockedForComplaints
        timeZoneId
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const SEARCH_FLEETS = gql`
  query transferCompanySearchFleets($data: SearchFleetsRequestParams!, $skip: Boolean!) {
    searchFleets(data: $data) @skip(if: $skip) {
      results {
        id
        name
        transferCompanyId
        transferCompanyName
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const FLEET_CAPACITY = gql`
  query FleetCapacity($params: FleetCapacityParams!) {
    fleetCapacity(params: $params) {
      results {
        id
        fleetId
        fromDate
        toDate
        fromTime
        toTime
        weekDays
        vehicleCategory
        capacity
        safetyMargin
        updated
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const UPDATE_FLEET = gql`
  mutation UpdateFleet($data: FleetInput!) {
    updateFleet(data: $data)
  }
`;

export const CREATE_FLEET = gql`
  mutation CreateFleet($data: FleetInput!) {
    createFleet(data: $data)
  }
`;

export const REMOVE_FLEET = gql`
  mutation RemoveFleet($id: Int!) {
    removeFleet(id: $id)
  }
`;

export const CREATE_FLEET_CAPACITY = gql`
  mutation CreateFleetCapacity($data: FleetCapacityInput!) {
    createFleetCapacity(data: $data) {
        id
    }
  }
`;

export const UPDATE_FLEET_CAPACITY = gql`
  mutation UpdateFleetCapacity($data: FleetCapacityUpdateInput!) {
    updateFleetCapacity(data: $data) {
        id
        capacity
    }
  }
`;

export const REMOVE_FLEET_CAPACITY = gql`
  mutation DeleteFleetCapacity($id: Int!) {
    deleteFleetCapacity(id: $id)
  }
`;

export const FLEET_FARES = gql`
query fleetFares ($params: FleetFareParams) {
  fleetFares(params: $params) {
   results {
    id
    geoZoneId
    vehicleConfigurationId
    hubTenderId
    fareInbound
    fareOutbound
    fareInboundChild
    fareOutboundChild
    fareInboundInfant
    fareOutboundInfant
    hubName
    iataCode
    geoZoneName
    vehicleCategory
    currencyCode
  }
    pagination {
      pageSize
      totalPages
      currentPage
      totalResults
    }  
  }
}
`;

export const FLEET_FARES_GEOZONES = gql`
query fleetFares ($params: FleetFareParams) {
  fleetFares(params: $params) {
   results {
    geoZoneId
    geoZoneName
  }
    pagination {
      pageSize
      totalPages
      currentPage
      totalResults
    }  
  }
}
`;
